var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isTouchDevice = function isTouchDevice() {
  return isBrowser() && 'ontouchstart' in window;
};

var prepareClassName = function prepareClassName(name) {
  return String(name).replace(/\s/g, '-').toLowerCase();
};

var parsedJsonOrNull = function parsedJsonOrNull(data) {
  var result = null;

  try {
    result = JSON.parse(data);
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Catch exception on parse value with JSON.parse:', err);
    }
  }

  return result;
};

var DEFER_TIMEOUT = 1000;

var getDeferFunctionImplementation = function getDeferFunctionImplementation(timeout) {
  var isRequestIdleCallbackAvailable = ('requestIdleCallback' in window);
  var deferFunction = isRequestIdleCallbackAvailable ? window.requestIdleCallback : setTimeout;
  var deferParams = isRequestIdleCallbackAvailable ? {
    timeout: timeout
  } : timeout;
  return {
    deferFunction: deferFunction,
    deferParams: deferParams
  };
};

var removeJsOrCss = function removeJsOrCss(filename) {
  var isJs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var tags = document.getElementsByTagName(isJs ? 'script' : 'link');

  for (var i = tags.length; i >= 0; i -= 1) {
    if (tags[i] && tags[i].getAttribute(isJs ? 'src' : 'href') !== null && tags[i].getAttribute(isJs ? 'src' : 'href').indexOf(filename) !== -1) {
      tags[i].parentNode.removeChild(tags[i]);
    }
  }
};

var removeElementsByClassName = function removeElementsByClassName(className) {
  var elements = document.querySelectorAll(".".concat(className));
  elements.forEach(function (element) {
    element.remove();
  });
};

var removeElementById = function removeElementById(id) {
  var elem = document.querySelector("#".concat(id));

  if (elem) {
    elem.remove();
  }
};

var runOnUserInteraction = function runOnUserInteraction(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFER_TIMEOUT;
  var USER_INTERACTION_EVENTS = ['mousemove', 'touchmove'];

  var _getDeferFunctionImpl = getDeferFunctionImplementation(timeout),
      deferFunction = _getDeferFunctionImpl.deferFunction,
      deferParams = _getDeferFunctionImpl.deferParams;

  var eventHandler = function eventHandler() {
    deferFunction(callback, deferParams);
    USER_INTERACTION_EVENTS.forEach(function (eventName) {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  USER_INTERACTION_EVENTS.forEach(function (eventName) {
    window.addEventListener(eventName, eventHandler);
  });
};

export { isBrowser, isTouchDevice, parsedJsonOrNull, prepareClassName, removeElementById, removeElementsByClassName, removeJsOrCss, runOnUserInteraction };